import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { NotificationService } from '../../../../services/notification.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { AdminService } from '../../../../services/admin.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';

@Component({
  selector: 'app-list-of-contract',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, FormsModule],
  providers: [Base64UrlService],
  templateUrl: './list-of-contract.component.html',
  styleUrl: './list-of-contract.component.css'
})

export class ListOfContractComponent{

  @ViewChild('dt2') dt2: any;
  userName: any;
  companyName: any;
  lang: any;
  contractList: any;
  monthDropdown: any;
  yearDropdown: any;
  userCode: any;
  // These hold filtered data
  visibleData: any[] = [];
  totalCount: number = 0;
  monthList: number[] = [];
  selectedMonth: number | null = null;
  selectedYear: number | null = null;
  dashboard_msg: string | null = null;
  msgType: string | null = null;

  timeSheetDate: string = '';
  timeSheetDateOrg: string = '';

  constructor(private route: ActivatedRoute, private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, private ns: NotificationService, private as: AdminService, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }

  ngOnInit() {
    this.userName = this.auth.getName();
    this.companyName = this.auth.getCompanyName();
    this.userCode = this.auth.getCode();
    this.pageTitle.setTitle('menu.contract');
    if (isPlatformBrowser(this.platformId)) {
      this.selectedYear = new Date().getFullYear();
      this.selectedMonth = new Date().getMonth()+1;
      
      this.timeSheetDate = Base64UrlService.encode(this.en.encryptionAES(this.selectedYear + "-" + (this.selectedMonth!).toString().padStart(2, '0') + "-01"));
      this.timeSheetDateOrg = this.selectedYear + "-" + (this.selectedMonth!).toString().padStart(2, '0') + "-01";
      this.getYear();
      this.monthList = Array.from({ length: 12 }, (_, i) => i + 1);
    }
  }

  getYear() {
    this.ns.getYearList()
      .subscribe({
        next: (resYearList: any) => {
          this.yearDropdown = resYearList.data;
          this.getContractList();
          // this.getAssociatesList('2025-07-01');
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout();
			      return	
          }
        }
      });
  }

  getContractList() {
    // const dateFormat = this.selectedYear + "-" + this.selectedMonth;
    const filters = {
      startDate: this.selectedYear + "-" + this.selectedMonth,      
      selectedCustomer: '-1',
      selectedSupplierId: '-1',
      selectedBranch: '-1'
    }
    // this.ns.getContract(dateFormat)
    this.as.getGroupContract(filters)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // this.contractList = res.data.map((item: any) => {
            //   return {
            //     ...item,
            //     jobOrderIdOrg: item.jobOrderID,
            //     jobOrderID: Base64UrlService.encode(this.en.encryptionAES(item.jobOrderID.toString()))
            //   }
            //   // this.applyEncryption();
            // }); 
            
            // this.contractList = res.data.map((supplier: any) => ({
            //   ...supplier,
            //   sectionDto: supplier.sectionDto.map((section: any) => ({
            //     ...section,
            //     jobOrderDtos: section.jobOrderDtos.map((job: any) => ({
            //       ...job,
            //       jobOrderIdOrg: job.jobOrderID,
            //       jobOrderID: Base64UrlService.encode(
            //         this.en.encryptionAES(job.jobOrderID.toString())
            //       )
            //     }))
            //   }))
            // }));
            this.contractList = res.data.map((supplier: any) => {
              const searchTextParts: string[] = [];
              searchTextParts.push(supplier.supplier);
              supplier.sectionDto.forEach((section: any) => {
                searchTextParts.push(section.sectionName);

                section.jobOrderDtos.forEach((job: any) => {
                  searchTextParts.push(
                    job.contractNo,
                    job.jobOrderID,
                    job.userName
                  );
                });
              });

              return {
                ...supplier,
                supplierIdOrg: supplier.customerID,
                supplierID: Base64UrlService.encode(
                  this.en.encryptionAES(supplier.customerID.toString())
                ),
                comSearchText: searchTextParts.join(' ').toLowerCase(),
                sectionDto: supplier.sectionDto.map((section: any) => ({
                  ...section,
                  jobOrderDtos: section.jobOrderDtos.map((job: any) => ({
                    ...job,
                    jobOrderIdOrg: job.jobOrderID,
                    jobOrderID: Base64UrlService.encode(
                      this.en.encryptionAES(job.jobOrderID.toString())
                    )
                  }))
                }))
              };
            });
            
            // this.totalCount = this.contractList.length;
            this.totalCount = this.contractList.reduce((supplierAcc: number, supplier: any) => {
                  
                  const sectionCount = supplier.sectionDto.reduce((sectionAcc: number, section: any) => {
                      
                      return sectionAcc + (section.jobOrderDtos?.length || 0);
                  }, 0); 
                  
                  // Add the total section count to the main supplier accumulator
                  return supplierAcc + sectionCount;
              }, 0);
            this.updateVisibleData();
          }
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			      return
          } else {

          }
        }
    })
  }

  getSupplierRowspan(supplier: any) {
    return supplier.sectionDto.reduce((sum: number, sec: any) => {
      return sum + sec.jobOrderDtos.length;
    }, 0);
  }

  getSectionRowspan(section: any) {
    return section.jobOrderDtos.length;
  }
  ngAfterViewInit(): void {
    // 
  }

  fncCng(event: any, dateType: any) {
    // let dateFormat = this.getDateFromEvent(event);
    let date = event.target.value;
    if (dateType == 'year') {
      this.selectedYear = date;
    } else if (dateType == 'month') {
      this.selectedMonth = date;
    }
    this.timeSheetDate = Base64UrlService.encode(this.en.encryptionAES(this.selectedYear + "-" + (this.selectedMonth!).toString().padStart(2, '0') + "-01"));
    this.timeSheetDateOrg = this.selectedYear + "-" + (this.selectedMonth!).toString().padStart(2, '0') + "-01";
    this.getContractList();
  }

  applyFilterGlobal($event: Event) {
    const input = $event.target as HTMLInputElement;
    this.dt2.filterGlobal(input.value, 'contains');
    // Table triggers onFilter after this
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    this.updateVisibleData();
  }

  onPage(event: any) {
    this.updateVisibleData(event);
  }

  onSort() {
    this.updateVisibleData();
  }

  updateVisibleData(event?: any) {
    const filtered = this.dt2.filteredValue ?? this.contractList??[];
    const start = event?.first ?? this.dt2.first ?? 0;
    const rows = event?.rows ?? this.dt2.rows ?? 3;
    const end = start + rows;
    this.visibleData = filtered.slice(start, end);
  }

  onGlobalFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt2.filterGlobal(value, 'contains');
    setTimeout(() => {
    this.totalCount = this.dt2.filteredValue
      ? this.dt2.filteredValue.length
      : this.dt2.value.length; // fallback to total rows if no filter applied
  });
  }

  applyEncryption(dt: any) {
      dt.forEach((elm: any, ind: any) => {
        dt[ind].jobOrderID = Base64UrlService.encode(this.en.encryptionAES(elm.jobOrderID.toString()))
      });
      return dt;
  }

  reset() {
    this.dashboard_msg = null;
  }

  createSingle(comId: string, staffId: string, loginId: string) {
    let date = this.timeSheetDateOrg;
      this.ts.downloadContractListSingle(comId, this.timeSheetDateOrg, staffId)
        .subscribe({
          next: (res: any) => {
            // Create a blob from the response
            const blob = new Blob([res.body ?? res], { type: 'application/zip' });

            // Create a temporary download link
            const fileURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = fileURL;

            // Optional: derive filename from API or generate dynamically
            a.download = 'CL_' + date + '-'+loginId+'.zip';

            // Trigger the download
            a.click();

            // Cleanup
            URL.revokeObjectURL(fileURL);
          },
          error: (err: any) => {
            console.error('Error downloading file:', err);
            if (err.status == 401) {
              this.auth.logout();
              return
            }
          }
      })
  }
}
